var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionsUserIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.95 3.12c.839-.012 1.586.684 1.586 1.563v1.562h-1.562V4.683L9.087 7.026h10.45A2.356 2.356 0 0 1 21.88 9.37v10.156a2.356 2.356 0 0 1-2.344 2.344H5.474a2.356 2.356 0 0 1-2.344-2.344V8.784a2.363 2.363 0 0 1 1.758-2.27l12.695-3.345c.12-.03.243-.046.367-.049zM5.473 8.59a.768.768 0 0 0-.782.781v10.156c0 .443.34.782.782.782h14.062c.442 0 .781-.34.781-.782V9.37a.768.768 0 0 0-.78-.781zm12.938 5.03a1.172 1.172 0 1 1-1.658 1.658 1.172 1.172 0 0 1 1.658-1.657z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsUserIcon03);
export default __webpack_public_path__ + "static/media/actions-user_icon_03.ab02ba3c8e7769b255f2d3cb3e4fa508.svg";
export { ForwardRef as ReactComponent };